import { plural } from '@cian/utils';
import { TRANSPORT_TYPE_LABELS } from 'shared/constants/buildingLabels';
import type { IBuildingCard, IBuildingUnderground } from 'shared/types/buildingCard';
import { NBSP } from 'shared/constants/text';

const MAX_UNDERGROUNDS = 3;

export interface IUndergroundView {
  name: string | null;
  /** Цвет линии для иконки */
  color: string | null;
  /** «7 минут на транспорте» */
  timeText: string | null;
}

/** Станция метро для вывода: цвет линии и время до неё */
export function getUndergroundView({ name, lineColor, time, transportType }: IBuildingUnderground): IUndergroundView {
  const transportLabel = transportType ? (TRANSPORT_TYPE_LABELS[transportType]?.toLowerCase() ?? '') : '';

  return {
    name,
    color: lineColor ? `#${lineColor}` : null,
    timeText: time ? `${time}${NBSP}${plural(time, ['минута', 'минуты', 'минут'])} ${transportLabel}`.trimEnd() : null,
  };
}

/** Станции метро как `geo.html` монолита: первые три */
export function getUndergrounds(card: IBuildingCard): IUndergroundView[] {
  return card.undergrounds.slice(0, MAX_UNDERGROUNDS).map(getUndergroundView);
}
